export default state => state.inspector.solar.upload_dialog